import { request } from '@/utils';


/**
 * 获取热搜词 -- 找供应商
 */
export const getHotWords = async (): Promise<any> => {
  return request.post(
    '/api/trantor/service/engine/execute/VEGETA$top_eight_search_terms',
    { params: { request: {} } }
  );
};
/**
 * 获取热搜词 -- 找商机
 */
export const getHotWordsOpportunities = async (): Promise<any> => {
  return request.post(
    '/api/trantor/service/engine/execute/VEGETA$buyer_top_eight_search_terms',
    { params: { request: {} } }
  );
};

export const getBanners = async (): Promise<any> => {
  return request.post(
    '/api/trantor/service/engine/execute/VEGETA$query_resource_niche_detail_service',
    { params: { request: { id: 1 } } }
  );
};

export const getLayoutAllResources = async (): Promise<any> => {
  return request.post(
    '/api/trantor/service/engine/execute/VEGETA$query_pc_resource_config_interface',
    { params: {} }
  );
};
export const getLayoutAllResourcesByBusiness = async (): Promise<any> => {
  return request.post(
    '/api/trantor/service/engine/execute/VEGETA$query_pc_opportunity_resource_config',
    { params: {} }
  );
};


export const getCategoryFirstItem = async (): Promise<any> => {
  return request.post(
    '/api/trantor/service/engine/execute/VEGETA$query_all_primary_front_category',
    { params: {} }
  );
};

export const getCategorySecondItem = async (id: string): Promise<any> => {
  return request.post(
    '/api/trantor/service/engine/execute/VEGETA$get_subcategories_by_primary_category',
    { params: { request: { id } } }
  );
};

export const getBannerList = async (groupId?: string, memberId?: string): Promise<any> => {
  return request.get(
    '/api/ycx/caigou/portal/banner/listBanner',
    { params: { groupId, memberId } }
  );
};

export const getArticleList = async (groupId?: string, memberId?: string, pageStart: number = 1, pageSize: number = 5): Promise<any> => {
  return request.post(
    '/api/ycx/caigou/portal/article/listArticle',
    { pageStart, pageSize },
    { params: { groupId, memberId } }
  );
};

export const getArticleById = async (id: string | number): Promise<any> => {
  const response = await request.get(`/api/ycx/caigou/portal/article/getArticleById/${id}`);
  return response;
};


// 获取商机类目
export const getCategoryItemByBusiness = async (): Promise<any> => {
  return request.post(
    '/api/trantor/service/engine/execute/VEGETA$query_business_opportunity_front_cate_service',
    { params: { request: {  } } }
  );
};

export const getCategoryItemBySupplier = async (): Promise<any> => {
  return request.post(
    '/api/trantor/service/engine/execute/VEGETA$query_supplier_front_cate_service',
    { params: { request: {  } } }
  );
};

// 通过前台类目查询后台类目 
export const getCategoryByFrontCate = async (frontCateCode: string): Promise<any> => {
  return request.post(
    '/api/trantor/service/engine/execute/VEGETA$query_backend_category_by_bo_front_cate_service',
    { params: { request: { id: frontCateCode } } }
  );
};
